const displayText = (value) => {
  if (typeof value !== 'string') return '';
  const text = value.trim();
  return /^(null|undefined)$/i.test(text) ? '' : text;
};

const escapeHtml = (value) =>
  String(value).replace(
    /[&<>"']/g,
    (character) =>
      ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      })[character]
  );

export const buildLocationPopup = (marker, popupId, arrowUrl) => {
  const locations = [...marker.locationArray].sort((a, b) =>
    displayText(a.name).localeCompare(displayText(b.name), undefined, {
      numeric: true
    })
  );
  const rows = locations
    .map((location) => {
      const name = displayText(location.name);
      const address =
        displayText(location.location_address) ||
        displayText(location.building_address) ||
        displayText(marker.buildingAddress) ||
        'Address unavailable';
      const id = String(location.id || '').replace(/[^a-z0-9-]/gi, '');

      return `
      <div class="map-marker-content" onclick="pop('${id}')">
        <div class="map-marker-content-inner">
          <h6 class="inner">${escapeHtml(name)}</h6>
          <p class="inner"><strong>Address</strong>: ${escapeHtml(address)}</p>
        </div>
        <div style="padding-top: 6px; color: #5F5F5F;">
          <img src="${escapeHtml(arrowUrl)}" alt="arrow" />
        </div>
      </div>
    `;
    })
    .join('');

  return `
    <div id="${escapeHtml(popupId)}" class="map-marker">
      <div class="map-marker-header">
        <strong>${escapeHtml(displayText(marker.buildingName))}</strong>
      </div>
      ${rows}
    </div>
  `;
};
